import { User } from "../../../features/authentication/auth.model";
import { GepoUser } from "../../../features/tender_page/tender.module";

function canUserDeleteComment(
	commentCreator: GepoUser,
	currentUser: User | undefined
): boolean {
	return (
		currentUser?.userid?.toUpperCase() ==
		commentCreator.gaia_id?.toUpperCase()
	);
}


export default canUserDeleteComment;
